import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import gstdetails from '../../assets/img/gst.jpg';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getGSTDetails, updateGSTDetails } from '../../Redux/GSTDetails/action';
import { getCountryDropdown, getStateDropdown } from '../../Redux/User/action';
import ToasterMessage from '../ToasterMessage';
import loader from '../../assets/img/loader.gif';

const GSTDetails = () => {

    const [countries, setCountries] = useState();
    const [states, setStates] = useState();
    const [bankaccountdetails, setBankdaccountdetails] = useState({})
    const [toaster, setToaster] = useState("");
    const [isloader, setIsloader] = useState(false);

    useEffect(() => {
        getCountryDropdown()((response) => {
            if (response && response.status) {
                setCountries(response?.data)
            }
        });
        getGSTDetails()((response) => {
            if (response && response.status) {
                setBankdaccountdetails(response?.data)
                getStateDropdown(response?.data[0]?.country_id)((response) => {
                    if (response && response.status) {
                        setStates(response?.data)
                    }
                });
                formik.setValues({
                    ...formik.values,
                    gstname: response?.data[0]?.name ? response?.data[0]?.name : "",
                    gstin: response?.data[0]?.GSTIN ? response?.data[0]?.GSTIN : "",
                    address: response?.data[0]?.GSTAddress ? response?.data[0]?.GSTAddress : "",
                    loc: response?.data[0]?.location ? response?.data[0]?.location : "",
                    country_id: response?.data[0]?.country_id ? response?.data[0]?.country_id : "",
                })
            }
        });
    }, []);

    const validationSchema = Yup.object().shape({
        gstname: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid GST')
            .required('Required'),
        gstin: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid Name')
            .required('Required'),
        address: Yup.string()
            .required('Required'),
        loc: Yup.string()
            .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            gstname: "",
            gstin: "",
            address: "",
            loc: "",
            country_id: "",
        },
        validationSchema,
        onSubmit: (values) => {
            setIsloader(true)
            let formData = new FormData();
            formData.append("name", values.gstname);
            formData.append("GSTIN", values.gstin);
            formData.append("GSTAddress", values.address);
            formData.append("location", values.loc);
            formData.append("country_id", values.country_id);
            updateGSTDetails({ formData })((response) => {
                if (response && response.status) {
                }
                setIsloader(false)
                setToaster("Save Changes")
                setTimeout(() => {
                    setToaster("")

                }, 2000);
            });
        },
    });
    const getState = (e) => {
        formik.setValues({ ...formik.values, country_id: e.target.value })
        getStateDropdown(e.target.value)((response) => {
            if (response && response.status) {
                setStates(response?.data)
            }
        });
    }
    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Add GST Details </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Add GST Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <img src={gstdetails} alt='' className='img-fluid' />
                        </div>
                        <div className='col-lg-6'>
                            <div className="gst-details">
                                <Form onSubmit={formik.handleSubmit}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>GSTIN</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="gstname"
                                            value={formik.values?.gstname}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.gstname && !formik.errors.gstname}
                                            isInvalid={!!formik.errors.gstname}
                                            maxLength={15}
                                            placeholder="Enter GSTIN"
                                            style={{ textTransform: "uppercase" }}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.gstname}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>GST Name </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="gstin"
                                            value={formik.values?.gstin}
                                            onChange={formik.handleChange}
                                            isValid={formik.touched.gstin && !formik.errors.gstin}
                                            isInvalid={!!formik.errors.gstin}
                                            maxLength={30}
                                            placeholder="Enter GST Name"
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.gstin}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Address </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="address"
                                            value={formik.values?.address}
                                            onChange={formik.handleChange}
                                            maxLength={300}
                                            placeholder="Enter Address"
                                        />

                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Country </Form.Label>
                                        <Form.Select aria-label="Default select example" name='country' value={formik.values.country_id} onChange={(e) => getState(e)}>
                                            <option value="">Select Country</option>
                                            {countries?.map((country, index) =>
                                                <option key={index} value={country?.id}>{country?.country_name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>State </Form.Label>
                                        <Form.Select aria-label="Default select example" name='loc' value={formik.values.loc} onChange={formik.handleChange}>
                                            <option value="">Select State</option>
                                            {states?.map((state, index) =>
                                                <option key={index} value={state?.id}>{state?.state_name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>

                                    <div className='bank-details-btn mt-4'>
                                        {isloader == true ?
                                            <div className='loader'>
                                                <img src={loader} alt="" className='img-fluid' />
                                            </div>
                                            :
                                            <button type="submit" className="btn btn-primary" >Save</button>
                                        }
                                    </div>

                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default GSTDetails;